import React, { useEffect, useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useDispatch, useSelector } from "react-redux";
import { AmountFormatCell } from "components/common/formatter";
import {
  editFeeHeaderItems,
  getFeeHeaderItems,
} from "actions/fixedFeeHeader.action";
import EditFeeHeaderItems from "./EditFeeHeaderItems";
import { ActiveCell, EditCommandCell } from "../GridComponents";

const FixedFeeHeaderItemsList = (props) => {
  const [openForm, setOpenForm] = React.useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [editItem, setEditItem] = React.useState(null);

  const templatesData = useSelector(
    (state) => state.profitCostTemplate.fixedFeeHeaderItems
  );
  useEffect(() => {
    if (templatesData !== null && templatesData !== undefined) {
      setData(templatesData);
      setIsLoading(false);
    }
  }, [templatesData]);

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };
  const handleSubmit = async (event) => {
    setIsLoading(true);
    try {
      if (typeof event.vatCode === "object") {
        event.vatRate = event?.vatCode.rate;
        event.vatAmount = (event.vatCode.rate / 100) * event.netAmount;
        event.vatCode = event.vatCode.vatCodeId;
      }

      await dispatch(editFeeHeaderItems(props.item.fixedFeeHeaderID, [event]));
      setOpenForm(false);
      await dispatch(getFeeHeaderItems(props.item.fixedFeeHeaderID));
    } catch (error) {
      console.error("Error submitting:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );
  return (
    <div>
      {/* {isLoading && <LoadingPanel />} */}
      <Grid
        data={data}
        sortable={true}
        className="accounts-table p-4 pt-2 mb-4"
      >
        <Column field="details" title="Details" />
        <Column field="vatCode" title="Vat Code" />
        <Column field="nominalRef" title="Nominal Ref" />
        <Column field="netAmount" title="Net Amount" cell={AmountFormatCell} />
        <Column cell={ActiveCell} title="Active" width="80" />
        <Column title="Edit" cell={MyEditCommandCell} width="80" />
      </Grid>
      {openForm && (
        <EditFeeHeaderItems
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
          isSubmitting={isLoading}
        />
      )}
    </div>
  );
};

export default FixedFeeHeaderItemsList;
